import React from 'react';
import { useSelector } from 'react-redux';
import cx from 'classnames';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import bellSVG from '@plone/volto/icons/bell.svg';
import bellRingingSVG from '@plone/volto/icons/bell-ringing.svg';

import {
  formatarContagem,
  rotuloSino,
} from 'volto-ministerio-publico-federal/helpers/Notificacoes';

type Props = {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  expanded?: boolean;
};

/**
 * Sino da Toolbar, logo acima do avatar. O número vem do `NotificacoesPoller`;
 * com algo a ler o ícone troca para o sino tocando. A contagem também é
 * anunciada por uma região `aria-live` para quem usa leitor de tela.
 */
const NotificationsBell = ({ onClick, expanded = false }: Props) => {
  const naoLidas: number = useSelector(
    (state: any) => state.mpfNotificacoes?.contagem?.nao_lidas ?? 0,
  );
  const acoes: number = useSelector(
    (state: any) => state.mpfNotificacoes?.contagem?.acao_necessaria ?? 0,
  );
  const badge = formatarContagem(naoLidas);
  const rotulo = rotuloSino(naoLidas);

  return (
    <button
      type="button"
      className={cx('mpf-notificacoes__sino', {
        'mpf-notificacoes__sino--ativo': naoLidas > 0,
      })}
      aria-label={rotulo}
      aria-haspopup="dialog"
      aria-expanded={expanded}
      aria-controls="mpf-notificacoes-painel"
      onClick={onClick}
      id="toolbar-notifications"
      tabIndex={0}
    >
      <Icon
        name={naoLidas > 0 ? bellRingingSVG : bellSVG}
        size="30px"
        title={rotulo}
      />
      {badge && (
        <span
          className={cx('mpf-notificacoes__contador', {
            'mpf-notificacoes__contador--acao': acoes > 0,
          })}
          aria-hidden="true"
        >
          {badge}
        </span>
      )}
      <span className="sr-only" aria-live="polite">
        {naoLidas > 0 ? rotulo : ''}
      </span>
    </button>
  );
};

export default NotificationsBell;
